import { SAVED_SEARCHES_ROUTE, SAVED_SEARCHES_PATH } from '../../stores/page';

export const routes = {
  [SAVED_SEARCHES_ROUTE]: {
    path: SAVED_SEARCHES_PATH,
  },
};
